<template lang="pug">
  include /mixins.pug

  cabinet-body
    slot
</template>

<script>
import { cabinetCountersResource } from '@services/cabinet.service'
import { TYPES } from '@md/users/constances'

export default {
  components: {
    'cabinet-body': () => import('../Sections/BodyCustomer'),
  },

  provide() {
    return {
      generalCounters: this.generalCounters,
    }
  },

  data() {
    return {
      generalCounters: {
        value: {
          newOrders: 0,
          newCustomerOrders: 0,
          newShipperOrders: 0,
          newPayoffs: 0,
        },
      },
      userRole: window.userRole,
    }
  },

  computed: {
    isStaff() {
      return TYPES.ADMINISTRATOR === this.userRole || TYPES.MANAGER === this.userRole || TYPES.MANAGER_WAREHOUSE === this.userRole || TYPES.STORE_WH === this.userRole
    },
  },

  mounted() {
    if (this.isStaff) {
      this.getCounters()
    }
  },

  methods: {
    getCounters() {
      cabinetCountersResource.execute().then(res => {
        const { data: { item } } = res

        this.generalCounters.value = item
      })
    },
  },
}
</script>